import { PageIntro } from "@/components/kit/PageIntro";
import { FaqContact } from "@/components/blocks/FaqContact";
import { usePageMeta } from "@/components/site/Seo";
import { SITE } from "@/lib/content";

export default function Contact() {
  usePageMeta("Contact & Book a Free Consultation", `Book a free 20-minute consultation with Sony Mathew. Call or WhatsApp ${SITE.phoneDisplay}. ${SITE.city}. ${SITE.online}.`);
  return (
    <div data-testid="contact-page">
      <PageIntro testId="contact-hero" eyebrow="Contact" lines={["Let's talk about", <em key="c" className="text-gold-soft">your goals.</em>]} intro="Free 20-minute consultation. No obligation. Share a few details, or reach Sony directly on call or WhatsApp." />
      <FaqContact idPrefix="contact" showMap />
    </div>
  );
}
